import { AccessPointIcon } from './AccessPointIcon';

/**
 * author: Simran
 * id 4F013652-22DE-48CF-886B-A0FB995E8B41
 * name access-point
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/access-point.svg
 * tags
 */
export const WirelessIcon = AccessPointIcon;
export default WirelessIcon